module.exports = __webpack_public_path__ + "img/tc.2d382a9a.png";